module.exports = __webpack_public_path__ + "img/blog4.d1582ad8.jpg";